import { BrandLockup } from "./BrandLockup";
import { ExternalLink, Mail, Phone } from "lucide-react";

export function Footer({ content }) {
  return (
    <footer className="site-footer" data-testid="footer-section">
      <div className="footer-main" data-testid="footer-main">
        <div className="footer-company-block" data-testid="footer-company-block">
          <BrandLockup testIdPrefix="footer-brand" />
          <strong data-testid="footer-company-name">{content.company}</strong>
          <p data-testid="footer-address">{content.address}</p>
        </div>

        <div className="footer-column" data-testid="footer-contact-column">
          <p className="footer-heading" data-testid="footer-contact-heading">{content.contactLabel}</p>
          <div className="footer-link-list footer-links" data-testid="footer-contact-links">
            <a href={`tel:${content.phone}`} data-testid="footer-phone-link"><Phone size={15} aria-hidden="true" /><span>{content.phone}</span></a>
            <a href={`mailto:${content.email}`} data-testid="footer-email-link"><Mail size={15} aria-hidden="true" /><span>{content.email}</span></a>
          </div>
        </div>

        <div className="footer-column" data-testid="footer-explore-column">
          <p className="footer-heading" data-testid="footer-explore-heading">{content.exploreLabel}</p>
          <div className="footer-link-list footer-links" data-testid="footer-explore-links">
            <a className="footer-corporate-link" href={content.websiteUrl} target="_blank" rel="noreferrer" data-testid="footer-corporate-website-link"><span>{content.websiteLabel}</span><ExternalLink size={14} aria-hidden="true" /></a>
            <a className="footer-anchilex-link" href={content.anchilexUrl} target="_blank" rel="noreferrer" data-testid="footer-anchilex-website-link"><span>{content.anchilexLabel}</span><ExternalLink size={14} aria-hidden="true" /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom" data-testid="footer-bottom">
        <p data-testid="footer-copyright">{content.copyright}</p>
      </div>
    </footer>
  );
}